import { render, staticRenderFns } from "./CreditDetails.vue?vue&type=template&id=0ad99f5a&scoped=true"
import script from "./CreditDetails.vue?vue&type=script&lang=js"
export * from "./CreditDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad99f5a",
  null
  
)

export default component.exports